










import Component from "vue-class-component";
import { Vue } from "vue-property-decorator";
import UserListPage from "@/custom/page/useradmin/user/UserListPage.vue";
import MenuLayoutPage from "@/custom/page/common/MenuLayoutPage.vue";

const selectMenuKey = 'UserAdministrationPage_selectMenu';
export const currentPath = '/user-administration-page';
@Component({ components: { UserListPage, MenuLayoutPage } })
export default class UserAdministrationPage extends Vue {
  menus = [
    // { title: 'Danh sách người dùng', icon: 'mdi-account-multiple', routeName: 'UserListPage' },
    // { title: 'Danh sách vai trò', icon: 'mdi-account-supervisor-circle', routeName: 'RoleListPage' },
    { title: 'Danh sách người dùng', icon: 'mdi-key-variant', routeName: 'PermissionListPage' },
    { title: 'Phân quyền', icon: 'mdi-key-variant', routeName: 'PermissionGrantPage' },
  ];

  menuMini = false;

  get contentWidth() {
    return this.menuMini ? 90 + 45 : 266 + 45;
  }

  get contentLeftPosition() {
    return this.menuMini ? 90 : 266;
  }

  onMenuMiniChange(mini) {
    this.menuMini = mini;
  }
}
